function MobileMenu() {
    const veggieburger = document.querySelector('.veggie-burger')
    const menuButton = document.querySelector('button[data-menu-toggle="mobile-menu"]')
    const menuArea = document.querySelector('.mobile-site-header__menu-area')
    const menuAreaChildren = menuArea.children[0]
    const menuAreaTL = gsap.timeline({
        paused: true,
        onReverseComplete: reversedAnimationClasses
    })

    gsap.set(menuArea, { maxHeight: '0%', height: '0', clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)' })
    gsap.set(menuAreaChildren.children, { opacity: 0, yPercent: 10 })

    menuAreaTL.to(menuArea, {
        maxHeight: 'calc(100vh - 60px)',
        height: 'calc(100vh - 60px)',
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
        ease: 'power1.out',
        duration: 0.3,
    })
    .to(menuAreaChildren.children, {
        opacity: 1,
        yPercent: 0,
        stagger: {
            each: 0.2
        }
    })

    function toggleMenu() {
        if (menuArea.classList.contains('active')) {            
            closeMenu()  
        } else {
            openMenu() 
        }
    }

    function openMenu() {
        menuArea.classList.add('active')
        veggieburger.classList.add('active')
        menuAreaTL.timeScale(1)
        menuAreaTL.play()
    }

    function closeMenu() {        
        menuAreaTL.timeScale(2)
        menuAreaTL.reverse()
    }

    function reversedAnimationClasses() { 
        menuArea.classList.remove('active')
        veggieburger.classList.remove('active')
    }
    
    menuButton.addEventListener('click', toggleMenu)
}

export default MobileMenu